import styled from 'styled-components';

import { Text } from '@/nova/components';
import { CFG } from '../../../../../../theme/configurator-tokens';
import { hiddenScrollbar , cardHover } from '../../../../../../theme/configurator-keyframes';
import { FINISH } from '../../finish.tokens';

export const Root = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
`;

export const Scroll = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 12px 16px;
  ${hiddenScrollbar};
`;

export const SectionLabel = styled(Text)`
  font-size: 16px;
  line-height: 1;
  color: ${CFG.foreground};
`;

export const SectionLabelLg = styled(Text)`
  margin-top: 24px;
  font-size: 18px;
  line-height: 1;
  color: ${CFG.foreground};
`;

export const EmailInput = styled.input`
  margin-top: 12px;
  width: 100%;
  border-radius: 12px;
  border: 2px solid ${FINISH.inputBorder};
  background: transparent;
  padding: 12px 14px;
  font-size: 16px;
  line-height: 24px;
  color: ${FINISH.inputText};

  &::placeholder {
    color: ${FINISH.inputPlaceholder};
  }
  &:focus {
    border-color: ${FINISH.inputBorderFocus};
    outline: none;
  }
`;

export const Methods = styled.div`
  margin-top: 12px;
`;

/* Inline "payment declined" banner — keeps the card form on screen (the Pay
   button is the retry) while making the failure clear: a tinted, bordered row
   with an alert glyph + the message. Replaces the old bare red sentence. */
export const ErrorAlert = styled.div`
  margin-top: 12px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  border-radius: 12px;
  border: 1px solid ${FINISH.errorAlertBorder};
  background: ${FINISH.errorAlertBg};
  padding: 12px 14px;
`;

export const ErrorAlertIcon = styled.span`
  display: flex;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  margin-top: 1px;
  align-items: center;
  justify-content: center;
`;

export const ErrorAlertText = styled(Text)`
  font-size: 14px;
  line-height: 1.35;
  color: ${FINISH.errorText};
`;

/* ----------------------------- order total + pay ---------------------------- */

export const Footer = styled.div`
  flex-shrink: 0;
  padding: 8px 12px 16px;
`;

export const TotalRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid ${FINISH.paneDivider};
  padding: 12px;
`;

export const TotalLabels = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TotalLabel = styled(Text)`
  font-size: 20px;
  font-weight: 700;
  line-height: 1.25;
  color: ${CFG.base50};
`;

export const TotalSub = styled(Text)`
  font-size: 14px;
  line-height: 1.1;
  color: ${FINISH.termsText};
`;

export const TotalAmount = styled(Text)`
  white-space: nowrap;
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
  color: ${CFG.foreground};
`;

export const PayButton = styled.button`
  margin-top: 12px;
  display: flex;
  height: 48px;
  width: 100%;
  cursor: pointer;
  /* Cursor-following hover glow + lit hairline ring (shared with the CTA Button). */
  ${cardHover}
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border: none;
  background: ${CFG.brand};
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: ${FINISH.payButtonText};
  transition: opacity 150ms ease;

  &:disabled {
    cursor: default;
    opacity: 0.7;
  }
  &:disabled:hover::before,
  &:disabled:hover::after,
  &:disabled:focus-visible::before,
  &:disabled:focus-visible::after {
    opacity: 0;
  }
`;

export const PayButtonLabel = styled(Text)`
  display: inline;
`;
